import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const DashboardLayout = () => {
  const location = useLocation();

  // Map pathnames to titles
  const titles = {
    "/dashboard": "Welcome back!",
    "/Receive_transaction": "Receiving Transactions",
    "/Send_transaction": "Send Transactions",
    "/payment_link": "Payment Link",
    "/Settelment": "Settlement History",
    "/developer_section": "Developer Section",
  };

  // ✅ initialize based on screen size
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    return window.innerWidth >= 700;
  });

  // ✅ listen for resize events too
  useEffect(() => {
    const handleResize = () => {
        console.log(window.innerWidth);
      if (window.innerWidth < 700) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    window.addEventListener("resize", handleResize);

    // check once on mount & route change
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [location.pathname]);

  const title = titles[location.pathname] || "Dashboard";
  return (
    <div id="wrapper" className="counter-scroll">
      <div id="page">
        <div className={`layout-wrap loader-off ${sidebarOpen ? "full-width" : ""}`}>
          {/* Sidebar */}
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

{/* Right Section */}
<div className="section-content-right">
  <Header
    title={title}
    sidebarOpen={sidebarOpen}
    setSidebarOpen={setSidebarOpen}
  />
  <div className="main-content p-4">
    <Outlet />
  </div>
</div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
